export class Queue<T> {

    protected items: T[] = [];
    private _version: number = 0;

    get version(): number {
        return this._version;
    }

    get size(): number {
        return this.items.length;
    }

    get first(): T {
        if (this.size > 0) {
            return this.items[0];
        }
    }

    get last(): T {
        if (this.size > 0) {
            return this.items[this.size - 1];
        }
    }

    enqueue(item: T): void {
        this.items.push(item);
        this._version++;
    }

    dequeue(n?: number): T[] {
        if (!n) {
            n = 1;
        }
        if (n > 0) {
            return this.items.splice(0, n);
        }
    }

    slice(n): T[] {
        return this.items.slice(0, n);
    }

    clear(): void {
        this.items = [];
    }

    getItems(): T[] {
        return this.items.slice(0);
    }

    hasItems(): boolean {
        return !this.isEmpty();
    }

    isEmpty(): boolean {
        return this.size === 0;
    }
}
